export const getAdminDefaults = ({
    isReduxAdminPage,
}) => ({
    isReduxAdminPage,
})
